export default {
  resetSurveyAnswer({ commit }) {
    commit("setSurvey", {})
  }
}
